import { takeLatest, call, put } from 'redux-saga/effects';
import { postPatientEmergencyContactSuccess, postPatientEmergencyContactFailure, putPatientEmergencyContactSuccess, putPatientEmergencyContactFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../../api/client';
function* postPatientEmergencyContactRequest(action) {
    try {
const response = yield call(apiPost, 'api/post-patient-emergencyContact', action.payload);
        yield put(postPatientEmergencyContactSuccess(response));
    } catch (error) {
        yield put(postPatientEmergencyContactFailure(error?.response?.message || error));
    }
}


function* putPatientEmergencyContactRequest(action) {
    try {
const response = yield call(apiPut, `api/edit-patient-emergencyContact/${action.payload._id}`, action.payload);
        yield put(putPatientEmergencyContactSuccess(response));
    } catch (error) {
        yield put(putPatientEmergencyContactFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('patientEmergencyContact/postPatientRegistrationRequest', postPatientEmergencyContactRequest);
    yield takeLatest('patientEmergencyContact/putPatientEmergencyContactRequest', putPatientEmergencyContactRequest);
}

export default saga;